import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

function RailItem({ it, onClick }) {
  const up = (it.chg ?? 0) >= 0;
  return (
    <button onClick={onClick} className="inline-flex items-center gap-1.5 px-4 shrink-0 hover:opacity-80 transition-opacity" data-testid="rail-item">
      <span className="text-[0.64rem] uppercase tracking-[0.08em] text-[#F5F7FB]/60">{it.label}</span>
      <span className="text-[0.68rem] text-[#F5F7FB] tnum">{it.value}</span>
      {it.unit && <span className="text-[0.56rem] text-[#F5F7FB]/40">{it.unit}</span>}
      {it.chg != null && (
        <span className={`text-[0.62rem] tnum ${up ? "text-[#22c55e]" : "text-[#f87171]"}`}>
          {up ? "▲" : "▼"} {up ? "+" : ""}{it.chg}%
        </span>
      )}
      {it.obs && <span className="text-[0.52rem] text-[#F5F7FB]/40 tnum">obs {it.obs}</span>}
      {it.status && it.status !== "LIVE" && (
        <span className={`text-[0.52rem] uppercase tracking-wide ${it.status === "DELAYED" ? "text-amber-400" : "text-[#f87171]"}`}>
          {it.status}
        </span>
      )}
    </button>
  );
}

export function TickerRail() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => {
    const load = () => api.get("/public/ticker-rail").then(({ data: d }) => setData(d)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  if (!data?.items?.length) return null;
  const doubled = [...data.items, ...data.items];
  return (
    <div className="h-9 bg-[#0F2145] border-b border-[#F5F7FB]/10 overflow-hidden relative group" data-testid="ticker-rail">
      <div className="flex items-center h-full whitespace-nowrap animate-[rail-scroll_45s_linear_infinite] group-hover:[animation-play-state:paused] w-max">
        {doubled.map((it, i) => <RailItem key={`${it.label}-${i}`} it={it} onClick={() => nav("/wire")} />)}
        <span className="text-[0.56rem] text-[#F5F7FB]/50 px-4 shrink-0 tnum">
          as of {new Date(data.as_of).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", timeZone: "America/New_York" })} ET
        </span>
      </div>
      <style>{`@keyframes rail-scroll { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
      <button onClick={() => nav("/vdr-rdi")} data-testid="rail-disclosure"
        className="absolute right-0 top-0 h-full z-10 flex items-center gap-1 px-3 bg-[#0F2145] border-l border-[#F5F7FB]/10 text-[0.54rem] uppercase tracking-[0.1em] text-[#F5F7FB]/60 hover:text-bb-gold transition-colors">
        Live composite spot · updated every minute · methodology
      </button>
    </div>
  );
}
